angular
        .module('mainMenu.components', [])
        .component('mainMenu', {
            templateUrl: 'ng/components/mainMenu/mainMenu.html',
            bindings: {
                menuitemlist: '=',
                user:'=',
                homeico:'=',
                menucarousel:'='
            },
            controllerAs: 'mainMenuCtrl',
            controller: function ($scope, FactoryObj) {
                $scope.goTo = $scope.$parent.goTo;
                
                $scope.changeActive = $scope.$parent.changeActive;
                
                this.$onInit = function () {  
                	initializeMainCarouselMenu();                	
                }
                
                $scope.cleanFactoryObj = function(){
                	FactoryObj.idAppSimulation = null;
        			FactoryObj.origin = null;
                }
            }
        });